import Dragcolumn2d from"@fusioncharts/powercharts/src/chart/dragcolumn2d";export default Dragcolumn2d;


//////////////////
// WEBPACK FOOTER
// ./~/fusioncharts/viz/dragcolumn2d.js
// module id = 6jkh
// module chunks = 5